import { useSyncExternalStore } from "react";
import { getConnectivitySnapshot, subscribeConnectivity } from "./connectivityStore";

export function useConnectivity(): boolean {
  const verdict = useSyncExternalStore(subscribeConnectivity, getConnectivitySnapshot);
  return verdict !== "offline";
}
